import { $t } from "@/lib/i18nHelpers";
import { FormFields, ListField } from "@/types";

export const systemName = "other";

// onlyfats (CO-15589): "Other" is where creators get paid by Venmo, Cash App, Zelle and the like
export const listField: ListField = { value: systemName, text: $t("Other (Venmo, Cash App, Zelle…)") };

export const formFields: FormFields = [
  {
    name: "details",
    label: $t("Details"),
    type: "textarea",
    placeholder: $t("Which app and your account there, e.g. Venmo @yourname, Cash App $yourname, Zelle email or phone"),
    autoGrow: true,
    rows: 3,
    rules: ["required"],
    validationMode: "aggressive",
  },
];
